import { useTranslate } from "@refinedev/core";
import { BrandKit } from "../../types";
import { BrandKitPreviewCard } from "./BrandKitPreviewCard";
import { ListPanel } from "pages/components/ListPanel/";
import { ItemCreateCard } from "pages/components/ItemCreateCard/";
import { ListWrapper } from "pages/components/ListWrapper/";

export const BrandKitPanel = ({
  brandkits,
  organizationId,
}: {
  brandkits: BrandKit[];
  organizationId: string;
}) => {
  const t = useTranslate();
  return (
    <ListWrapper>
      <ListPanel
        items={brandkits}
        title={t("pages.components.ListPanel.brandkit", { count: 2 })}
        getSearchText={(item: BrandKit) => item.name}
        renderItems={(filteredBrandkits: BrandKit[]) => {
          return filteredBrandkits?.map((item) => (
            <div key={item.id}>
              <div
                style={{
                  margin: "20px 10px",
                  maxWidth: filteredBrandkits?.length === 1 ? "50%" : undefined,
                }}
              >
                <BrandKitPreviewCard
                  brandKit={item}
                  organizationId={organizationId}
                />
              </div>
            </div>
          ));
        }}
      />
      <ItemCreateCard
        itemName={t("pages.components.ListPanel.brandkit", {
          count: 1,
        }).toLowerCase()}
        title={t("media.brandkit.index.startABrandkit")}
        description={t("media.brandkit.index.startABrandkitDescription")}
      />
    </ListWrapper>
  );
};
